import React from "react";
import { useWindowDimensions } from "@app/hooks";
import LanguageModalHeader from "./LanguageModalHeader";
import LanguageModalBody from "./LanguageModalBody";
import { LanguageModalWrapper } from "./styles";
import { useIsMobile } from '@utils/CalVW.tsx';

const LanguageModal = ({ closeModal }: any) => {
  const { width: w, height } = useWindowDimensions();
  const isMobile = useIsMobile();
  const wSize =
    w > 1400 ? w / 3.4 : w > 1200 ? w / 2.8 : w > 1200 ? w / 2.2 : w / 2.2;

  return (
    <LanguageModalWrapper
      style={{ width: isMobile ? '99%' : wSize, height: height / 3.6, minHeight: 230 }}
    >
      <LanguageModalHeader closeModal={closeModal} />
      <LanguageModalBody closeModal={closeModal} />
    </LanguageModalWrapper>
  );
};

export default LanguageModal;
